/*
Akhila 03/20/2023 2699762545 added letter format stepper
Sohel 03/22/2023 2699762545  Integrated Dispositions Save and Get API
Sohel 03/22/2023 2698964415 Letter Field Payload Changes
Akhila 03/23/2023 2698964415 added letter format print now save api
Dilip 03/24/2023 2699762545 added prior letter get and save api
Sohel 03/30/2023 2699762545 reset letter Format Data
Guru Prasad 03/30/2023 2699762545 Integrated Letter Usage api
Ravi 06/21/2023 2699762545 fixed submit issue
*/

import { createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost } from '../../../../util/Rest';
import {
  LETTER_TYPE,
  LETTER_FOR,
  DELIVERY_METHOD,
  DISPOSITION_CODE,
} from '../../../../constants/Lookup';
import { submissionEnd } from '../../CommonActions/commonActions';

const initialState = {
  isBasicInfoLoading: false,
  basicInfoSuccessMsg: null,
  basicInfoErrorMsg: null,
  basicInfoStatus: null,
  dockey: '',
  letterCode: '',
  isLetterFieldsLoading: false,
  letterFieldsErrorMsg: null,
  letterFieldsSuccessMsg: null,
  letterFieldsStatus: null,
  dropDownData: {},
  allLetterCode: [],
  allLetterGroupCode: [],
  letterCodeData: {},
  dispositionData: {},
  letterFieldsData: [],
  clientInformationData: {},
  createdByData: [],
  priorLetterData: {},
  LetterGroupData: {},
  LetterUsageData: [],
  isLoading: false,
  loading: false,
};

const newLetterMaintenance = createSlice({
  name: 'newLetterMaintenance',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isBasicInfoLoading = true;
      state.basicInfoErrorMsg = null;
    },
    setLetterCode: (state, action) => {
      state.isLetterFieldsLoading = false;
      state.letterFieldsErrorMsg = false;
      state.basicInfoSuccessMsg = false;
      state.letterCode = action.payload;
    },
    fetchError: (state, action) => {
      state.basicInfoErrorMsg = action.payload;
      state.isBasicInfoLoading = false;
    },
    postBasicInfoData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
      state.letterCode = action.payload?.response?.letterCode;
    },
    postClientInformationData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.response;
      state.isBasicInfoLoading = false;
    },
    postPriorLettersData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.response;
      state.isBasicInfoLoading = false;
    },

    postDispositionsData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
    },
    postNewLetterGroupData: (state, action) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = action.payload.status;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
    },
    getBasicInfoData: (state, action) => {
      state.basicInfoData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getLetterGroupData: (state, action) => {
      state.LetterGroupData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getClientInformationData: (state, action) => {
      state.clientInformationData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getPriorLettersData: (state, action) => {
      state.priorLetterData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getDispositionsData: (state, action) => {
      state.dispositionData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getletterFormatData: (state, action) => {
      state.letterFormatData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getLetterCodeData: (state, action) => {
      state.letterCodeData = action.payload;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    getCreatedByData: (state, action) => {
      state.createdByData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetBasicInfoData: (state) => {
      state.basicInfoErrorMsg = null;
      state.basicInfoStatus = null;
      state.basicInfoSuccessMsg = null;
      state.isBasicInfoLoading = false;
    },
    resetLetterMaintenanceData: (state) => {
      state.basicInfoData = {};
      state.letterCodeData = {};
      state.dispositionData = {};
      state.letterFieldsData = [];
      state.clientInformationData = {};
      state.priorLetterData = {};
      state.LetterGroupData = {};
      state.letterCode = '';
      state.letterFormatData = {};
    },
    resetGetLetterFormatData: (state) => {
      state.letterFormatData = {};
      state.letterCode = '';
    },
    fetchLetterFields: (state) => {
      state.isLetterFieldsLoading = true;
      state.letterFieldsErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    postLetterFormatFieldsData: (state, action) => {
      state.isLetterFieldsLoading = false;
      state.letterFieldsSuccessMsg = action.payload?.message;
      state.letterFieldsStatus = action.payload?.status;
      state.letterFieldsErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    postLetterFormatData: (state, action) => {
      state.isLetterFieldsLoading = false;
      state.letterFieldsSuccessMsg = action.payload?.response;
      state.letterFieldsStatus = action.payload?.status;
      state.letterFieldsErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    postLetterFormatPrintData: (state, action) => {
      state.isLetterFieldsLoading = false;
      state.letterFieldsSuccessMsg = action.payload?.response;
      state.letterFieldsStatus = action.payload?.status;
      state.letterFieldsErrorMsg = null;
      state.isBasicInfoLoading = false;
    },
    fetchLetterFieldsError: (state, action) => {
      state.letterFieldsErrorMsg = action.payload;
      state.isLetterFieldsLoading = false;
    },
    resetLetterFormatFieldsData: (state) => {
      state.letterFieldsErrorMsg = null;
      state.letterFieldsStatus = null;
      state.letterFieldsSuccessMsg = null;
      state.isLetterFieldsLoading = false;
    },
    resetLetterFormatData: (state) => {
      state.letterFieldsErrorMsg = null;
      state.letterFieldsStatus = null;
      state.letterFieldsSuccessMsg = null;
      state.isLetterFieldsLoading = false;
      state.letterFormatData = {};
    },
    getAllLetterCode: (state, action) => {
      state.allLetterCode = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    getLetterFormatFields: (state, action) => {
      state.letterFieldsErrorMsg = null;
      state.letterFieldsSuccessMsg = null;
      state.isLetterFieldsLoading = false;
      state.letterFieldsData = action.payload;
    },
    getAllLetterGroupCode: (state, action) => {
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
      state.allLetterGroupCode = action.payload;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    resetLetterGroupData: (state, action) => {
      state.letterCodeData = {};
      state.isBasicInfoLoading = false;
    },
    getLetterUsageData: (state, action) => {
      state.loading = false;
      state.basicInfoSuccessMsg = false;
      state.basicInfoErrorMsg = false;
      state.LetterUsageData = action.payload;
    },
    resetLetterUsageData: (state, action) => {
      state.LetterUsageData = {};
      state.loading = false;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
    },
  },
});

export default newLetterMaintenance.reducer;

export const {
  fetchStart,
  fetchError,
  postBasicInfoData,
  setLetterCode,
  getBasicInfoData,
  resetBasicInfoData,
  resetLetterMaintenanceData,
  fetchLetterFields,
  postLetterFormatFieldsData,
  fetchLetterFieldsError,
  resetLetterFormatFieldsData,
  getAllLetterCode,
  fetchDropDownData,
  postLetterFormatData,
  getletterFormatData,
  resetLetterFormatData,
  getAllLetterGroupCode,
  postNewLetterGroupData,
  getLetterCodeData,
  resetLetterGroupData,
  postDispositionsData,
  getDispositionsData,
  getLetterFormatFields,
  postClientInformationData,
  postPriorLettersData,
  getClientInformationData,
  getPriorLettersData,
  postLetterFormatPrintData,
  getCreatedByData,
  getLetterGroupData,
  resetLetterUsageData,
  getLetterUsageData,
} = newLetterMaintenance.actions;

export const postLetterBasicInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/save/letterentity`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postBasicInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postClientInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/save/letterclient`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postClientInformationData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPriorLetterInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/save/priorLetter`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postPriorLettersData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postDispositionsInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/save/letterdisposition`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postDispositionsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postNewLetterGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/save/lettergroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postNewLetterGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchClientInformationData = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/letterclient/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getClientInformationData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchPriorLettersData = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/letterprior/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getPriorLettersData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchBasicInfoData = (lettercode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/letter/${lettercode}`)
      .then((data) => {
        dispatch(setLetterCode(lettercode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getBasicInfoData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchLetterGroupData = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/lettercodegroup/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getLetterGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchLetterFormatData = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/letterformat/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getletterFormatData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchDispositionsData = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/letterdisposition/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDispositionsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchLetterCodeData = (letterGroupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/lettergroup/${letterGroupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getLetterCodeData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllLetterGroupCode = (letterType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/find/all/lettergroupcodeanddescription/${letterType}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllLetterGroupCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postLetterFormatFields = (details) => {
  return (dispatch) => {
    dispatch(fetchLetterFields());
    httpPost(`newlettermaintenance/save/letterfield`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postLetterFormatFieldsData(data));
        } else {
          dispatch(fetchLetterFieldsError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchLetterFieldsError(error.message));
      });
  };
};
export const fetchLetterFormatFields = (letterCode) => {
  return (dispatch) => {
    dispatch(fetchLetterFields());
    httpGet(`newlettermaintenance/get/letterfield/${letterCode}`)
      .then((data) => {
        dispatch(setLetterCode(letterCode));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchLetterFieldsError(data?.data?.error));
        } else if (data && data.status && data.status === 200) {
          dispatch(getLetterFormatFields(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchLetterFieldsError(error.message));
      });
  };
};
export const postLetterFormat = (details) => {
  return (dispatch) => {
    dispatch(fetchLetterFields());
    httpPost(`newlettermaintenance/save/letterformat`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postLetterFormatData(data));
        } else {
          dispatch(fetchLetterFieldsError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchLetterFieldsError(error.message));
      });
  };
};
export const postLetterFormatPrint = (details) => {
  return (dispatch) => {
    dispatch(fetchLetterFields());
    httpPost(`newlettermaintenance/save/letterformat/printnow`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postLetterFormatPrintData(data));
        } else {
          dispatch(fetchLetterFieldsError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchLetterFieldsError(error.message));
      });
  };
};

export const fetchCreatedByDropDownData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/${type}/createdby`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCreatedByData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllLetterCode = () => {
  return (dispatch) => {
    httpGet(`newlettermaintenance/findbyletterCodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllLetterCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/lookup', {
      typeCode: [LETTER_TYPE, LETTER_FOR, DELIVERY_METHOD, DISPOSITION_CODE],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDataManagerRecordUsage = (letterCode) => {
  console.log(letterCode, 'letterCode');
  return (dispatch) => {
    dispatch(fetchLetterFields());
    httpGet(`newlettermaintenance/get/letter/usage/PRIOR_LETTER/${letterCode}`)
      .then((data) => {
        console.log(data, 'usaageLetteData');
        dispatch(setLetterCode(data));
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchLetterFieldsError(data?.data?.error));
        } else if (data && data.status && data.status === 200) {
          dispatch(getLetterUsageData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchLetterFieldsError(error.message));
      });
  };
};

export const resetBasicInfo = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoData());
  };
};

export const resetLetterMaintenance = () => {
  return (dispatch) => {
    dispatch(resetLetterMaintenanceData());
  };
};

export const resetLetterFormatFields = () => {
  return (dispatch) => {
    dispatch(resetLetterFormatFieldsData());
  };
};
export const resetLetterFormat = () => {
  return (dispatch) => {
    dispatch(resetLetterFormatData());
  };
};
export const resetLetterGroup = () => {
  return (dispatch) => {
    dispatch(resetLetterGroupData());
  };
};

export const resetLetterUsage = () => {
  return (dispatch) => {
    dispatch(resetLetterUsageData());
  };
};
